import {
  SALESX_GROUP_DETAIL,
  CREATE_SALESX_GROUP,
  SALESX_GROUP_NAME_UPDATE,
  SALESX_GROUP_DELETE,
  SALESX_GROUPS_LISTING,
  SALESX_USERS_LISTING,
} from '../../../constants/types/groupTypes';
import { IGroupState, IGroupAction, SalesXGroupInterface } from './interfaces';

const initialState: IGroupState = {
  groups: {
    loading: false,
    data: [],
    createLoading: false,
    deleteLoading: false,
    totalCount: 0,
  },
  selectedGroup: {
    loading: false,
    nameLoading: false,
    groupName: '',
    groupId: -1,
    users: [],
    searchTerm: '',
    totalCount: 0,
    showGlobalListing: false,
    deleteLoading: false,
    saveLoading: false,
    personalityFilters: [],
    isDeletable: true,
    message: '',
  },
  usersData: {
    loading: false,
    users: [],
    totalCount: 0,
    searchTerm: '',
  },
};

export const salesXGroupReducer = (state: IGroupState = initialState, action: IGroupAction) => {
  const newState = { ...state };
  switch (action.type) {
    //Sales X Global User Listing
    case SALESX_USERS_LISTING.LOAD:
      newState.usersData.loading = true;
      return newState;

    case SALESX_USERS_LISTING.LOAD_SUCCESS:
      newState.usersData.loading = false;
      newState.usersData.users = [...newState.usersData.users, ...action.payload.users];
      newState.usersData.totalCount = action.payload.totalCount;
      //newState.selectedGroup.showGlobalListing = true;
      return newState;

    case SALESX_USERS_LISTING.FAIL:
      newState.usersData.loading = false;
      return newState;

    case SALESX_USERS_LISTING.RESET:
      newState.usersData.users = [];
      newState.usersData.searchTerm = '';
      newState.usersData.totalCount = 0;
      newState.usersData.loading = false;
      return newState;

    case SALESX_USERS_LISTING.SET_SEARCH_TERM:
      newState.usersData.searchTerm = action.payload;
      return newState;

    case SALESX_USERS_LISTING.EXPORT_REMOVE:
      if (action.payload.checkedUsers.length > 0) {
        newState.usersData.users = newState.usersData.users.filter((user: any) => !action.payload.checkedUsers.includes(user.userId));
        newState.usersData.totalCount -= action.payload.checkedUsers.length;
      }
      if (action.payload.selectAllUsers) {
        if (action.payload.selectAllUsersExcept.length > 0) {
          newState.usersData.users = newState.usersData.users.filter((user: any) => action.payload.selectAllUsersExcept.includes(user.userId));
          newState.usersData.totalCount = action.payload.selectAllUsersExcept.length;
        } else {
          newState.usersData.users = [];
          newState.usersData.totalCount = 0;
        }
      }
      return newState;

    // Group Details (Group's Users Listing)
    case SALESX_GROUP_DETAIL.LOAD:
      newState.selectedGroup.loading = true;
      // if (action.payload.nameLoading) newState.selectedGroup.nameLoading = true;
      return newState;

    case SALESX_GROUP_DETAIL.SUCCESS:
      newState.selectedGroup.loading = false;
      newState.selectedGroup.groupId = action.payload.id;
      newState.selectedGroup.groupName = action.payload.name;
      newState.selectedGroup.totalCount = action.payload.totalCount;
      newState.selectedGroup.isDeletable = action.payload.isDeletable;
      //newState.selectedGroup.showGlobalListing = false;
      newState.selectedGroup.users = [...newState.selectedGroup.users, ...action.payload.users];
      return newState;

    case SALESX_GROUP_DETAIL.FAIL:
      newState.selectedGroup.loading = false;
      return newState;

    case SALESX_GROUP_DETAIL.APPLY_FILTERS:
      newState.selectedGroup.personalityFilters = action.payload;
      return newState;

    case SALESX_GROUP_DETAIL.RESET:
      newState.selectedGroup.loading = false;
      newState.selectedGroup.groupName = '';
      newState.selectedGroup.totalCount = 0;
      newState.selectedGroup.searchTerm = '';
      newState.selectedGroup.users = [];
      newState.selectedGroup.showGlobalListing = false;
      return newState;

    case SALESX_GROUP_DETAIL.UPDATE:
      newState.selectedGroup.loading = false;
      newState.selectedGroup.users = [...newState.selectedGroup.users, ...action.payload.users];
      return newState;

    case SALESX_GROUP_DETAIL.DELETE_LOAD:
      newState.selectedGroup.deleteLoading = true;
      return newState;

    case SALESX_GROUP_DETAIL.DELETE_SUCCESS:
      newState.selectedGroup.deleteLoading = false;
      if (!action.payload.deleteAll) {
        if (action.payload.exceptUsers.length > 0) {
          newState.selectedGroup.users = newState.selectedGroup.users.filter((user: any) => {
            return action.payload.exceptUsers.includes(user.userId);
          });
          newState.selectedGroup.totalCount = action.payload.exceptUsers.length;
        }
      } else {
        newState.selectedGroup.users = [];
        newState.selectedGroup.totalCount = 0;
      }

      if (action.payload.deleteUsers.length > 0) {
        newState.selectedGroup.users = newState.selectedGroup.users.filter((user: any) => {
          return !action.payload.deleteUsers.includes(user.userId);
        });
        newState.selectedGroup.totalCount -= action.payload.selectedUsersTotalCount;
      }
      newState.groups.data.forEach((group: any, index: any) => {
        if (group.groupId === newState.selectedGroup.groupId) {
          newState.groups.data[index].totalUsers -= action.payload.selectedUsersTotalCount;
        }
      });
      return newState;

    case SALESX_GROUP_DETAIL.DELETE_FAIL:
      newState.selectedGroup.deleteLoading = false;
      return newState;

    case SALESX_GROUP_DETAIL.ADD_LOAD:
      newState.selectedGroup.saveLoading = true;
      return newState;

    case SALESX_GROUP_DETAIL.ADD_SUCCESS:
      newState.selectedGroup.saveLoading = false;
      return newState;

    case SALESX_GROUP_DETAIL.ADD_FAIL:
      newState.selectedGroup.saveLoading = false;
      return newState;

    case SALESX_GROUP_DETAIL.GLOBAL_LISTING:
      newState.selectedGroup.showGlobalListing = action.payload;
      return newState;

    case SALESX_GROUP_DETAIL.RESET_USERS:
      newState.selectedGroup.totalCount = 0;
      newState.selectedGroup.users = [];
      return newState;

    // case SALESX_GROUP_DETAIL.ADD_USERS:
    //   newState.selectedGroup.totalCount = action.payload.totalCount;
    //   newState.selectedGroup.users = [...newState.selectedGroup.users, ...action.payload.users];
    //   newState.usersData.loading = false;
    //   return newState;

    case SALESX_GROUP_DETAIL.MESSAGE:
      newState.selectedGroup.message = action.payload.message;
      if (action.payload.message === '') {
        newState.selectedGroup.nameLoading = false;
      }
      return newState;

    // Sales X Groups Listings
    case SALESX_GROUPS_LISTING.LOAD:
      newState.groups.loading = true;
      return newState;

    case SALESX_GROUPS_LISTING.LOAD_SUCCESS:
      newState.groups.loading = false;
      newState.groups.data = [...newState.groups.data, ...action.payload.groups];
      newState.groups.totalCount = action.payload.totalCount;
      return newState;

    case SALESX_GROUPS_LISTING.FAIL:
      newState.groups.loading = false;
      return newState;

    case SALESX_GROUPS_LISTING.RESET:
      newState.groups.data = [];
      newState.groups.loading = false;
      newState.groups.totalCount = 0;
      return newState;

    case SALESX_GROUPS_LISTING.UPDATE_GROUP_USERS_COUNT:
      newState.groups.data.forEach((group, index) => {
        if (group.groupId === action.payload.gid) {
          newState.groups.data[index].totalUsers = action.payload.count;
        }
      });
      return newState;

    case SALESX_GROUPS_LISTING.EXPORT_REMOVE:
      if (action.payload.checkedGroups.length > 0) {
        newState.groups.data = newState.groups.data.filter((group: any) => !action.payload.checkedGroups.includes(group.groupId));
        newState.groups.totalCount -= action.payload.checkedGroups.length;
      }
      if (action.payload.selectAllGroups) {
        if (action.payload.selectAllGroupsExcept.length > 0) {
          newState.groups.data = newState.groups.data.filter((group: any) => action.payload.selectAllGroupsExcept.includes(group.groupId));
          newState.groups.totalCount = action.payload.selectAllGroupsExcept.length;
        } else {
          newState.groups.data = [];
          newState.groups.totalCount = 0;
        }
      }
      return newState;

    // Create Group
    case CREATE_SALESX_GROUP.LOAD:
      newState.groups.createLoading = true;
      return newState;

    case CREATE_SALESX_GROUP.SUCCESS:
      newState.groups.createLoading = false;
      const obj = {
        groupId: action.payload.id,
        groupName: action.payload.name,
        lastUpdated: 'just now',
        totalUsers: 0,
        isDeletable: true,
        exportStatus: false,
      };
      newState.groups.data = [obj, ...newState.groups.data];
      newState.selectedGroup = {
        loading: false,
        nameLoading: false,
        groupName: action.payload.name,
        groupId: action.payload.id,
        totalCount: 0,
        searchTerm: '',
        users: [],
        showGlobalListing: true,
        personalityFilters: [],
        saveLoading: false,
        deleteLoading: false,
        isDeletable: true,
      };
      return newState;

    case CREATE_SALESX_GROUP.FAIL:
      newState.groups.createLoading = false;
      return newState;

    // Group Name Update
    case SALESX_GROUP_NAME_UPDATE.LOAD:
      newState.selectedGroup.nameLoading = true;
      return newState;

    case SALESX_GROUP_NAME_UPDATE.SUCCESS:
      newState.selectedGroup.nameLoading = false;
      newState.selectedGroup.groupName = action.payload.groupName;
      // Updating groupName & lastUpdated in Groups
      const updatedGroups = [...newState.groups.data];
      const index = updatedGroups.findIndex((group: any) => group.groupId === action.payload.groupId);
      updatedGroups[index] = {
        ...updatedGroups[index],
        groupName: action.payload.groupName,
        lastUpdated: 'just now',
      };
      newState.groups.data = updatedGroups;
      return newState;

    case SALESX_GROUP_NAME_UPDATE.FAIL:
      newState.selectedGroup.nameLoading = false;
      return newState;

    // Group Deletion
    case SALESX_GROUP_DELETE.LOAD:
      newState.groups.deleteLoading = true;
      return newState;

    case SALESX_GROUP_DELETE.SUCCESS:
      newState.groups.deleteLoading = false;
      let groups = [...state.groups.data];
      let newGroups = groups.filter((group) => group.groupId !== action.payload);
      newState.groups.data = [...newGroups];
      return newState;

    case SALESX_GROUP_DELETE.FAIL:
      newState.groups.deleteLoading = false;
      return newState;

    default:
      return newState;
  }
};
